import React from "react";
interface ServiceItem {
  name: string;
  icon: string;
  text: string;
}
interface ServicesProps {
  data?: ServiceItem[];
}
export const Services: React.FC<ServicesProps> = ({ data }) => (
  <section id="confianca" className="relative py-24">
    <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white via-slate-50 to-white" />
    <div className="mx-auto max-w-6xl px-6 lg:px-8">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-blue-600">
          Operação conectada
        </p>
        <h2 className="mt-3 text-3xl font-semibold text-slate-900 sm:text-4xl">
          Do atendimento à gestão, tudo no mesmo fluxo
        </h2>
        <p className="mt-4 text-slate-600">
          Uma base para automatizar processos, preservar o contexto e dar
          visibilidade à sua equipe sem depender de ferramentas isoladas.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {data?.map((d, i) => (
          <div
            key={i}
            className="group rounded-2xl border border-slate-200/70 bg-white/90 p-6 text-left shadow-sm transition hover:-translate-y-1 hover:shadow-soft animate-fade-up"
            style={{ animationDelay: `${i * 90}ms` }}
          >
            <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600 transition group-hover:bg-blue-600 group-hover:text-white">
              <i className={`${d.icon} !text-2xl`}></i>
            </div>
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              {d.name}
            </h3>
            <p className="text-sm leading-relaxed text-slate-600">{d.text}</p>
          </div>
        )) ?? "loading"}
      </div>
    </div>
  </section>
);
